import { SecurityAccessConstants } from '../../utils/constants/endpoints/security-access/security-access-constants';
import * as i0 from "@angular/core";
export class RecaptchaService {
    constructor() { }
    executeRecaptcha(action) {
        return new Promise((resolve, reject) => {
            // @ts-ignore: This will suppress the TypeScript error for the 'grecaptcha' declaration
            grecaptcha.enterprise.ready(() => {
                // @ts-ignore
                grecaptcha.enterprise.execute(SecurityAccessConstants.RECAPTCHA_SITE_KEY, { action }).then((token) => {
                    resolve(token);
                }, (error) => {
                    reject(new Error('error'));
                });
            });
        });
    }
}
RecaptchaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RecaptchaService_Factory() { return new RecaptchaService(); }, token: RecaptchaService, providedIn: "root" });
